import {useLocation} from "react-router";

type LocationState = {
  record: { companyId: string, limitedPartnerPeople: any[], limitedPartnerCompanies: any[] }
}

export const useLocationState = () => {
  return useLocation<LocationState>()
}
